import API from "../../api/api";
const callApi = async (endpoint) => {
    try {
        const response = await API.get(endpoint);
        if (response.status === 200) {
            return response?.data?.data;
        } else {
            return response?.data?.data;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};

const MeetingService = {
    callSponsorMeetings: async () => {
        return callApi(`get-sponsor-meetings`);
    },
    callUserMeetings: async (page, perPage) => {
        return callApi(`get-user-meetings?page=${page}&perPage=${perPage}`);
    },
    addMeeting: async (data) => {
        return API.post("add-meeting", data)
            .then((response) => response?.data)
            .catch((error) => console.log(error.message));
    },
    updateMeeting: async (data) => {
        return API.post("update-meeting", data)
            .then((response) => response?.data)
            .catch((error) => console.log(error.message));
    },
    callUserMeetingsCount: async () => {
        return callApi(`user-meeting-count`);
    },

};

export default MeetingService;
